/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {ReactNode} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {TombstoneLoader} from '../components/loading/TombstoneLoader';

const loadingStyles = makeStyles(theme => ({
  tombstone : {
    width  : 'inherit',
    height : '83px'
  }
}));

/**
 * @WrappedLoadingField
 *
 * @param {boolean} loading: the loading state that will determine the tombstone
 */
const WrappedLoadingField = ({loading, children}: {loading: boolean; children: ReactNode}) => {
  const classes = loadingStyles();
  return (
    <>
      {loading ? (
        <div className={classes.tombstone}>
          <TombstoneLoader />
        </div>
      ) : (
        <>
          {children}
        </>
      )}
    </>
  );
};

export default WrappedLoadingField;
